import AddIcon from "assets/icons/AddIcon";
import VLButton from "../../../../uikit/Buttons/VLButton";

export default function AddClassButton({ onClick }: { onClick?: () => void }) {
  return (
    <VLButton
      size="small"
      type="secondary"
      icon={<AddIcon />}
      onClick={onClick}
    >
      Add Labels
    </VLButton>
  );
}
